import dayjs from 'dayjs'

export const formatDate = (date: Date, format?: string) => {
  const _format = format ?? 'DD/MM/YYYY'
  return dayjs(date).format(_format)
}
